import axios  from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const getFaqDropDown = async () => {
  try {
    const response = await apiService.get("/faq-categories-dropdown");
    return response.data
  } catch (error) {}
};
export const getQueriesBasedOnFilter = async(faqId)=>{
    try {
        const response =await apiService.get(`/get-category-faqs/${faqId}`)
        return response.data
    } catch (error) {
        
    }
}
